import { css, CSSResult } from "lit";

export const gameCanvasStyles: CSSResult = css`
.game {
            height: 100%;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: auto auto 1fr auto;
            grid-column-gap: 0px;
            grid-row-gap: 0px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
        }

        .title {
            text-align: center;
            margin-top: 10px;
        }

        .title .buttons {
            display: flex;
            flex-direction: row;
            overflow: auto;
            padding: 5px;
        }

        .title .button {
            display: block;
            padding: 8px 12px;
            margin: 3px;
            border: none;
            background-color: #7a85ff;
            color: #fff;
            border-radius: 5px;
            cursor: pointer;
            transition: background-color 0.3s ease;
            font-size: 20px;
            position: absolute;
            top: 0;
            left: 0;
        }

        .header {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-grow: 1;
            position: relative;
            margin-top: 10px;
        }

        .header img {
            width: 50vw;
            height: 53vh;
            image-rendering: pixelated;
        }

        .header img:nth-child(n + 2) {
            position: absolute;
        }

        .content {
            flex-grow: 1;
            overflow: auto;
            margin-top: -10px;
            margin-bottom: 60px;
            padding: 0 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-size: 22px;
            line-height: 1.6;
            flex-direction: column;
            padding-bottom: 5%;
            position: fixed;
            bottom: -5vh;
            justify-self: center;
            max-width: 53.5vw;
        }

        .start {
            bottom: 32vh !important;
        }

        .content p:last-of-type {
            margin: 0;
        }

        .footer {
            position: fixed;
            bottom: 0;
            left: 0;
            width: auto;
            display: flex;
            background-color: rgba(22, 41, 66, 0.9);
            border: 1px solid rgba(255, 255, 255, 0.3);
            padding: 20px;
            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); 
            border-radius: 6px;
            margin: 5px;
            justify-content: space-between;
            align-items: center;
            margin: 10px;
        }

        .inventory {
            margin-left: auto;
            background-color: rgba(22, 41, 66, 0.9);
            border: 1px solid rgba(255, 255, 255, 0.3);
            padding: 30px 30px 20px 30px;
            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); 
            border-radius: 6px;
            margin: 0px 10px 10px auto;
            position: fixed;
            bottom: 0;
            right: 0;
        }

        .inventory p {
            margin: 0;
        }

        .inventory ul {
            list-style: none;
            padding: 0;
        }

        .inventory li {
            margin-top: 5px;
        }
        .inventory-name {
            padding-bottom: 20px;
        }

        .footer .buttons {
            display: flex;
            flex-direction: row;
            overflow: auto;
            padding: 5px;
        }

        .footer .button {
            display: block;
            padding: 8px 12px;
            margin: 3px;
            border: none;
            background-color: #7a85ff;
            color: #fff;
            border-radius: 5px;
            cursor: pointer;
            transition: background-color 0.3s ease;
            font-size: 20px;
        }

        .footer .button:hover {
            background-color: #5f69e3;
        }
        .action-text {
            margin-left: 10px;
            font-size: 25px;
        }
        .startup-room-start-button {
        background-color: #7a85ff;
        }
        .startup-room-footer {
            display: flex;
            justify-content: center;
            width: 97.7%;
            margin: 0;
        }
        .info-room-footer {
            display: flex;
            justify-content: center;
            width: 97.8%;
            margin: 0;
        }
        .info-room-content, .wizard-room-content {
            flex-grow: 1;
            overflow: auto;
            margin-top: 50px;
            padding: 0 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-size: 22px;
            line-height: 1.6;
            flex-direction: column;
            max-height: calc(100vh - 200px);
            overflow-y: auto;
            max-width: 53.5vw;
            justify-self : center;
            width: 40%;
        }

        .info-room-content {
            width: 100%!important;
            max-width: 70vw!important;
        }
        
        .info-room-content p {
            max-width: 80%;
            margin: 70px auto;
        }

        .selected-inventory-item {
            border: 2px solid white;
            padding: 5px;
            display: inline-block;
        }

        .reset {
            position: fixed !important;
            left: 20px !important;
            top: 20px !important;
        }
        
        @media screen and (max-width: 768px) {

            .info-room-content {
                font-size: 14px;
                margin-top: 10px;

            }

            .info-room-content p {
                max-width: 100%;
            }
            .content {
                padding-bottom: 20%;
            }
            .startup-room-footer {
                width: 89.1%;
            }
        }
    `;